import { Grid, IconButton, XCloseIcon } from '@metarouter-private/mr-mui';
import PropTypes from 'prop-types';
import React from 'react';

export default function DrawerHeader({ onClose, children }) {
  return (
    <Grid container direction="row" alignItems="center" justifyContent="space-between">
      <Grid item xs={11}>
        {children}
      </Grid>
      <Grid item>
        <IconButton onClick={onClose} data-testid="drawer-close-button">
          <XCloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}

DrawerHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
